export default {
    desensitizeChineseName(name) {
        if (!name || typeof name !== 'string' || name.length === 0) {
            return '';
        }
        if(name.includes('*')){
            return name;
        }
        if (name.length === 1) {
            return '*';
        }
        return '*' + name.substring(1)
    },
    validPhone(phoneNumber){
        if (!phoneNumber || typeof phoneNumber !== 'string' || phoneNumber.length === 0) {
            return false;
        }
        // 验证输入是否为有效的手机号
        if (!/^\d{11}$/.test(phoneNumber)) {
            return false;
        }
        return true;
    },
    desensitizePhone(phoneNumber) {
        if (!phoneNumber || typeof phoneNumber !== 'string' || phoneNumber.length === 0) {
            return '';
        }
        if(phoneNumber.includes('*')){
            return phoneNumber;
        }
        // 验证输入是否为有效的手机号
        if (!/^\d{11}$/.test(phoneNumber)) {
            return '-';
        }

        // 使用正则表达式替换中间四位数字为星号
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    desensitizeId(idCard) {
        if (!idCard || typeof idCard !== 'string' || idCard.length === 0) {
            return '';
        }
        if(idCard.includes('*')){
            return idCard;
        }
        // 验证输入是否为有效的身份证
        // if (!/^\d{18}$/.test(idCard)) {
        //     return '-';
        // }
        if (!/^[1-9][0-9]{16}[0-9xX]$/.test(idCard)) {
            return '-';
        }
        // 使用正则表达式替换中间四位数字为星号
        return idCard.replace(/(\d{1})\d{16}(\d{1})/, '$1****************$2');
    }
}